import { RowData, Table } from '@tanstack/react-table';
import { MutableRefObject } from 'react';
import { useVirtual, VirtualItem } from 'react-virtual';
import merge from 'lodash/merge';

export const useRowVirtualizer = <TData extends RowData>(
  table: Table<TData>,
  tableContainerRef: MutableRefObject<HTMLDivElement>,
): {
  virtualRows: VirtualItem[] | undefined;
  paddingTop: number;
  paddingBottom: number;
} => {
  const rowVirtualizerOptions = table.options.meta?.rowVirtualization?.options ?? {};

  const rowVirtualizer = table.options.meta?.rowVirtualization?.enabled
    ? useVirtual(
        merge(
          {},
          {
            parentRef: tableContainerRef,
            overscan: 5,
            size: table.getRowModel().rows.length,
          },
          rowVirtualizerOptions,
        ),
      )
    : undefined;

  const virtualRows = rowVirtualizer ? rowVirtualizer?.virtualItems : undefined;
  const paddingTop = rowVirtualizer && virtualRows && virtualRows.length > 0 ? virtualRows[0].start || 0 : 0;
  const paddingBottom =
    rowVirtualizer && virtualRows && virtualRows.length > 0
      ? rowVirtualizer.totalSize - (virtualRows[virtualRows.length - 1].end || 0)
      : 0;

  return { virtualRows, paddingTop, paddingBottom };
};
